module.exports = __webpack_public_path__ + "img/mallaciclonicaconcintaplastica.ab24b8e0.jpg";